export default {
  subtitle: 'Wir senden die ausgewählten Ereignisse per POST an Ihre Endpunkte, signiert mit dem Endpunkt-Secret.',
  regenerate_confirm: 'Neues Signatur-Secret erzeugen? Das aktuelle Secret funktioniert sofort nicht mehr.',
  delete_confirm: 'Diesen Endpunkt löschen? Er erhält dann keine Ereignisse mehr.',
  consecutive_failures: '{{count}} aufeinanderfolgende Fehlschläge',
  columns: {
    url: 'Endpunkt',
    events: 'Ereignisse',
    status: 'Status',
    secret: 'Secret',
  },
  statuses: {
    active: 'Aktiv',
    disabled: 'Deaktiviert',
    auto_disabled: 'Automatisch deaktiviert',
  },
  buttons: {
    create: 'Endpunkt hinzufügen',
    edit: 'Bearbeiten',
    regenerate_secret: 'Neues Secret',
    delete: 'Löschen',
  },
  toasts: {
    load_error: 'Die Webhook-Endpunkte konnten nicht geladen werden.',
    error: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
    deleted: 'Endpunkt gelöscht.',
  },
};
